"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = Search;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactHelmet = require("react-helmet");
var _reactRedux = require("react-redux");
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _reactRouter = require("react-router");
var ListingsActions = _interopRequireWildcard(require("../listings/listingsModule"));
var _CommonSections = _interopRequireDefault(require("../shared/CommonSections"));
var _utils = require("../utils");
var _withAppContext = require("../HOCs/withAppContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// eslint-disable-line import/no-named-as-default

function Search(_ref) {
  var context = _ref.context,
    searchListings = _ref.searchListings,
    searchFilteredListings = _ref.searchFilteredListings,
    setSearch = _ref.setSearch;
  var _useParams = (0, _reactRouter.useParams)(),
    term = _useParams.term;
  var getTitle = context.getTitle,
    isPublic = context.isPublic;
  var sanitizedTerm = (0, _utils.escapeHTML)(term);

  // Trigger analytics events and filter listings on component load
  (0, _react.useEffect)(function () {
    if (isPublic) {
      if ((0, _utils.canUseDOM)() && window.utag) {
        (0, _utils.sendPublicView)();
      }
    }
    setSearch(sanitizedTerm);
  }, []);

  // Make filtered listings change when the route changes
  (0, _react.useEffect)(function () {
    searchListings(sanitizedTerm);
  }, [term]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, {
    title: getTitle("Search: ".concat(sanitizedTerm))
  }), /*#__PURE__*/_react.default.createElement("h2", {
    id: "ac-search-results-for",
    style: {
      textTransform: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "ShowingResultsFor",
    values: {
      term: sanitizedTerm
    }
  })), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_CommonSections.default, {
    overrideListings: searchFilteredListings
  })));
}
Search.propTypes = {
  searchListings: _propTypes.default.func.isRequired,
  context: _propTypes.default.shape({
    getTitle: _propTypes.default.func.isRequired,
    isPublic: _propTypes.default.bool
  }).isRequired,
  searchFilteredListings: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  setSearch: _propTypes.default.func.isRequired
};
function mapStateToProps(state) {
  return {
    searchFilteredListings: state.listings.searchFilteredListings,
    betas: state.betas || {}
  };
}
var mapDispatchToProps = {
  searchListings: ListingsActions.searchListings,
  setSearch: ListingsActions.setSearch
};
var _default = exports.default = (0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search));